import React, { useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/DashboardStyle.module.css';
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import Button from '../Styles/Button.module.css';
import { useSelector } from 'react-redux';
import { handlePasswordUpdate} from "../../services/routes.services";
import { FaEye, FaEyeSlash  } from "react-icons/fa";

const ChangePassword = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const { isAuthenticated, user,token } = useSelector((state) => state.auth);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const oldPasswordHandler=()=>{
      if(showOldPassword === false){
          setShowOldPassword(true)
      }else{
          setShowOldPassword(false)
      }
    }
    const newPasswordHandler=()=>{
      if(showNewPassword === false){
          setShowNewPassword(true)
      }else{
          setShowNewPassword(false)
      }
    }
    const confirmPasswordHandler=()=>{
      if(showConfirmPassword === false){
          setShowConfirmPassword(true)
      }else{
          setShowConfirmPassword(false)
      }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (!oldPassword || !newPassword || !confirmPassword) {
            setError('All fields are required.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('New password and confirm password do not match.');
            return;
        }

        // Add any additional validation as required here
        try {
            const response = await handlePasswordUpdate(
              { oldPassword, newPassword },
                token
            );

            if (response.status === 200) {
                setSuccess('Password changed successfully.');
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
            } else {
                setError('Error changing password.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }

    };

    return (
        <div>
            <DashBoardLeftProfileMenu />
            <div className={'containerStyla ' + Style.Dashboardscreen + " " + Style.BussinesList}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.newFormStyle +" " + Style.chngPass}>
                                <div className={Style.Center}>
                                    <h2 className={Style.changePasTit}>Change Password</h2>
                                </div>
                                {error && <div className={Style.error}>{error}</div>}
                                {success && <div className={Style.success}>{success}</div>}
                                <form id="myform" method="post" noValidate onSubmit={handleSubmit}>
                                    <div className={Style.formContainer}>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Old Password</label>
                                                <input
                                                    type={showOldPassword ? 'text' : 'password'}
                                                    className={Style.inputStyle}
                                                    value={oldPassword}
                                                    onChange={(e) => setOldPassword(e.target.value)}
                                                />
                                                <button className={Style.showPass} type="button" onClick={oldPasswordHandler}>
                                                    {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                                                </button>
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>New Password</label>
                                                <input
                                                    type={showNewPassword ? 'text' : 'password'}
                                                    className={Style.inputStyle}
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                />
                                                <button className={Style.showPass} type="button" onClick={newPasswordHandler}>
                                                    {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                                                </button>
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Confirm Password</label>
                                                <input
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    className={Style.inputStyle}
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />
                                                <button className={Style.showPass} type="button" onClick={confirmPasswordHandler}>
                                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                </button>
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol2 + ' ' + Style.fromBtn}>
                                                <button type="submit" className={Style.subBtn}>Submit</button>
                                                <button type="button" className={Style.clearBtn} onClick={() => {
                                                    setOldPassword('');
                                                    setNewPassword('');
                                                    setConfirmPassword('');
                                                    setError('');
                                                    setSuccess('');
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>              
                                </form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default ChangePassword;
